"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AdminLogs_vue_1 = __importDefault(require("../../pages/adminLogs/AdminLogs.vue"));
const AdminOrderLogs_vue_1 = __importDefault(require("../../pages/adminOrderLogs/AdminOrderLogs.vue"));
const AdminUserGroups_vue_1 = __importDefault(require("../../pages/adminUserGroups/AdminUserGroups.vue"));
const AdminUsers_vue_1 = __importDefault(require("../../pages/adminUsers/AdminUsers.vue"));
const AdminTranslations_vue_1 = __importDefault(require("../../pages/adminTranslations/AdminTranslations.vue"));
const AdminNews_vue_1 = __importDefault(require("../../pages/adminNews/AdminNews.vue"));
const AdminNewsletters_vue_1 = __importDefault(require("../../pages/adminNewsletters/AdminNewsletters.vue"));
const AdminContracts_vue_1 = __importDefault(require("../../pages/adminContracts/AdminContracts.vue"));
const AdminConfigs_vue_1 = __importDefault(require("../../pages/adminConfigs/AdminConfigs.vue"));
const AdminCoupons_vue_1 = __importDefault(require("../../pages/adminCoupons/AdminCoupons.vue"));
const AdminCustomerImport_vue_1 = __importDefault(require("../../pages/adminCustomerImport/AdminCustomerImport.vue"));
const AdminBanners_vue_1 = __importDefault(require("../../pages/adminBanners/AdminBanners.vue"));
const AdminPriceAndStockChecker_vue_1 = __importDefault(require("../../pages/adminPriceChecker/AdminPriceAndStockChecker.vue"));
exports.default = [
    {
        name: 'admin_logs',
        path: '/admin/logs',
        component: AdminLogs_vue_1.default,
        meta: { requiresAuth: true, title: 'Logs' }
    },
    {
        name: 'admin_logs_api',
        path: '/api/logs',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'admin_order_logs',
        path: '/admin/order-logs',
        component: AdminOrderLogs_vue_1.default,
        meta: { requiresAuth: true, title: 'Order Logs' }
    },
    {
        name: 'admin_order_logs_api',
        path: '/api/order-logs',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'admin_order_logs_details_api',
        path: '/api/order-logs/:id(\\d+)?/get-details',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'admin_user_groups',
        path: '/admin/user-groups',
        component: AdminUserGroups_vue_1.default,
        meta: { requiresAuth: true, title: 'User Groups' }
    },
    {
        name: 'admin_user_groups_api',
        path: '/api/user-groups/:id(\\d+)?',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'admin_users',
        path: '/admin/users',
        component: AdminUsers_vue_1.default,
        meta: { requiresAuth: true, title: 'Users' }
    },
    {
        name: 'admin_users_api',
        path: '/api/users/:id(\\d+)?',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'customers_api',
        path: '/api/customers/:id(\\d+)?',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'customers_api_info',
        path: '/api/customers/:id(\\d+)?/info',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'customers_api_post',
        path: '/api/customers',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'customers_api_import_customer',
        path: '/api/import/customer',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'customers_api_customer_groups',
        path: '/api/customers/customer-groups',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'admin_translations',
        path: '/admin/translations',
        component: AdminTranslations_vue_1.default,
        meta: { requiresAuth: true, title: 'Translations' }
    },
    {
        name: 'admin_translations_api',
        path: '/api/translations',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'admin_translations_api_write_out_translations',
        path: '/api/write-out-translations',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'admin_news',
        path: '/admin/news',
        component: AdminNews_vue_1.default,
        meta: { requiresAuth: true, title: 'News' }
    },
    {
        name: 'admin_news_api',
        path: '/api/news/:id(\\d+)?',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'admin_news_api_by_category',
        path: '/api/news/by-category',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'admin_news_files_api',
        path: '/api/news-files/:id(\\d+)?',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'admin_carcass_files_api',
        path: '/api/carcass-return-files/:id(\\d+)?',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'admin_banner_files_api',
        path: '/api/banner-files/:id(\\d+)?',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'admin_newsletters',
        path: '/admin/newsletters',
        component: AdminNewsletters_vue_1.default,
        meta: { requiresAuth: true, title: 'Newsletters' }
    },
    {
        name: 'admin_newsletters_api',
        path: '/api/newsletters/:id(\\d+)?',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'admin_newsletter_bulk_delete_api',
        path: '/api/newsletter-bulk-delete',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'admin_contracts',
        path: '/admin/contracts',
        component: AdminContracts_vue_1.default,
        meta: { requiresAuth: true, title: 'Contracts' }
    },
    {
        name: 'admin_contracts_api',
        path: '/api/contracts/:id(\\d+)?',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'admin_accepted_contracts_api',
        path: '/api/accepted-contracts/:id(\\d+)?',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'admin_export_accepted_contract_users_api',
        path: '/api/export-accepted-contract-users/:id(\\d+)?',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'admin_carcass_api',
        path: '/api/carcass-returns',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'send_carcass_created_email_api',
        path: '/api/send-carcass-created-email',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'send_carcass_file_upload_email_api',
        path: '/api/send-carcass-file-upload-email',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'admin_carcass_api_get',
        path: '/api/carcass-returns/:customerId?',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'admin_get_carcass_files_api',
        path: '/api/carcass-return-files/:carcassId(\\d+)?',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'admin_configs',
        path: '/admin/configs',
        component: AdminConfigs_vue_1.default,
        meta: { requiresAuth: true, title: 'Configs' }
    },
    {
        name: 'admin_banned_axapta_product_import_rules_api',
        path: '/api/banned-axapta-product-import-rules',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'admin_banned_product_search_rules_api',
        path: '/api/banned-product-search-rules',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'admin_order_invoices_api',
        path: '/api/order-invoices/:id(\\d+)?',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'admin_order_notes_api',
        path: '/api/order-notes/:orderId(\\d+)?',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'admin_coupons',
        path: '/admin/coupons',
        component: AdminCoupons_vue_1.default,
        meta: { requiresAuth: true, title: 'Coupons' }
    },
    {
        name: 'admin_coupons_api',
        path: '/api/coupons/:id(\\d+)?',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'admin_customer_coupons_api',
        path: '/api/coupons/customer',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'admin_site_coupons_api',
        path: '/api/coupons/by-site',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'admin_upload_coupons_csv_api',
        path: '/api/coupons/upload-csv',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'admin_guarantee_product_returns_api',
        path: '/api/guarantee-product-returns',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'admin_create_customer_product_returns_api',
        path: '/api/create-customer-product-returns',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'admin_vehicle_types_api',
        path: '/api/vehicle-types',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'admin_vehicle_brands_api',
        path: '/api/vehicle-brands',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'admin_customer_import',
        path: '/admin/customer-import',
        component: AdminCustomerImport_vue_1.default,
        meta: { requiresAuth: true, title: 'Customer import' }
    },
    {
        name: 'admin_banners',
        path: '/admin/banners',
        component: AdminBanners_vue_1.default,
        meta: { requiresAuth: true, title: 'Banners' }
    },
    {
        name: 'admin_banners_api',
        path: '/api/banners/:id(\\d+)?',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'admin_get_banner_api',
        path: '/api/get-banner',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'admin_price_and_stock_checker',
        path: '/admin/price-and-stock-checker',
        component: AdminPriceAndStockChecker_vue_1.default,
        meta: { requiresAuth: true, title: 'Price and stock checker' }
    },
    {
        name: 'api_user_get_favorite_customers',
        path: '/api/users/favorite-customers',
        redirect: '',
        meta: { requiresAuth: true }
    }
];
